import Quill from 'quill';

const Embed = Quill.import('blots/embed');

export class MathliveBlot extends Embed {
  static create(value) {
    const node = super.create();
    node.dataset.value = value;
    const markup = document.createElement('span');
    markup.classList.add('mathlive-markup');
    markup.textContent = value;
    node.appendChild(markup);
    return node;
  }

  setMarkup(domNode) {
    this.markup = domNode.querySelector('.mathlive-markup');
  }

  constructor(domNode) {
    super(domNode);
    this.setMarkup(domNode);
  }

  static value(domNode) {
    return domNode.dataset.value;
  }

  static replaceHtmlString(str) {
    return str.replace(
      /(<span [^>]*class="mathlive-blot".*?>)\u{FEFF}<span contenteditable=(["'])false\2>(.*?)<\/span>\u{FEFF}(<\/span>)/gsu,
      '$1$3$4'
    );
  }
}
MathliveBlot.blotName = 'mathlive';
MathliveBlot.tagName = 'span';
MathliveBlot.className = 'mathlive-blot';

export default MathliveBlot;
